import { ReactElement } from 'react';
import { FormikContextType } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import withComponentLoader from '../../../../../hoc/withComponentLoader';
import AppWrappedInput from './../AppWrappedInput';
import RequiredIndicator from './../RequiredIndicator';

/**
 * Radio Button Set input base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} props.helperText helper text
 * @param {string[]|object[]} props.options list of options to display.  Should be list of strings or a list of objects with the shape {key: string, disabled: bool}.
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {boolean} props.isDisabled flag to indicate if input is interactive
 * @param {object} props.props the rest of the props
 * @returns Radio Button Set input stylized for custom
 */
const AppWrappedCheckbox = ({
	setLoading,
	label,
	formik,
	helperText,
	disabled,
	customOnChange,
	isRequired = false,
	isLoading = false,
	...props
}) => {
	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	return (
		<AppWrappedInput
			noIndent
			error={
				formik.touched[props.name] ? formik.errors[props.name] : null
			}
		>
			<FormControl variant='filled' fullWidth>
				<FormControlLabel
					control={
						<Checkbox
							name={props.name}
							onChange={e => {
								customOnChange && customOnChange(e);
								formik.setFieldValue(
									props.name,
									e.target.checked
								);
							}}
							onBlur={formik.handleBlur}
							disabled={disabled}
							checked={formik.values[props.name]}
						/>
					}
					label={
						<Typography variant='body1'>
							{isRequired ? <RequiredIndicator /> : null}
							{label}
						</Typography>
					}
				/>
				<FormHelperText>{helperText}</FormHelperText>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedCheckbox);
